import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import AnimatedPage from "../components/AnimatedPage";
import md5 from "js-md5";
import axios from "axios";
import swal from "sweetalert";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";

function Register() {
    const [err, setErr] = useState(null);
    const login = localStorage.getItem("user");
    const navigate = useNavigate();
    const [affiliate, setAffiliate] = useState(null);
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    
    // State ẩn/hiện mật khẩu
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();

    useEffect(() => {
        if (login) {
            navigate("/");
        } else {
            const urlParams = new URLSearchParams(window.location.search);
            const refParam = urlParams.get("ref");
            if (refParam) {
                setAffiliate(refParam);
            }
            if (localStorage.getItem("affiliate")) {
                setAffiliate(localStorage.getItem("affiliate"));
            }
        }
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify !== res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
    }, [login, navigate, affiliate, notify, setting]);

    const onSubmit = (data) => {
        const phoneNumberPattern = /^(0\d{9,10})$/;
        const regex = /^[a-zA-Z0-9]+$/;
        if (data.username.length < 6) {
            setError("username", { type: "minLength", message: "Tên đăng nhập tối thiểu 6 kí tự" });
            return false;
        }
        if (data.username.length > 11) {
            setError("username", { type: "minLength", message: "Tên đăng nhập tối đa 11 kí tự" });
            return false;
        }
        if (!regex.test(data.username)) {
            setError("username", { type: "minLength", message: "Tên đăng nhập không chứa khoảng trắng và ký tự đặc biệt" });
            return false;
        }
        if (data.password.length < 6) {
            setError("password", { type: "minLength", message: "Mật khẩu tối thiểu 6 kí tự" });
            return false;
        }
        if (data.password !== data.ippassword) {
            setError("ippassword", { type: "minLength", message: "Hai mật khẩu không khớp" });
            return false;
        }
        if (!data.name) {
            setError("name", { type: "minLength", message: "Vui lòng nhập đầy đủ họ tên" });
            return false;
        }
        if (data.name.length < 6 || data.name.indexOf(" ") === -1) {
            setError("name", { type: "minLength", message: "Vui lòng nhập họ tên trùng với thông tin ngân hàng" });
            return false;
        }
        if (!data.sdt) {
            setError("sdt", { type: "minLength", message: "Vui lòng nhập số điện thoại" });
            return false;
        }
        if (!phoneNumberPattern.test(data.sdt)) {
            setError("sdt", { type: "minLength", message: "Định dạng số điện thoại không hợp lệ" });
            return false;
        }
        if (data.paypwd.length < 6) {
            setError("paypwd", { type: "minLength", message: "Mật khẩu rút tiền tối thiểu 6 kí tự" });
            return false;
        }

        let formData;
        if (affiliate == null) {
            formData = {
                username: data.username.toLowerCase(),
                password: data.password,
                code: data.code === "" ? "admin" : data.code,
                sdt: data.sdt,
                name: data.name,
                paypwd: data.paypwd
            };
        } else {
            formData = {
                username: data.username.toLowerCase(),
                password: data.password,
                code: affiliate,
                sdt: data.sdt,
                name: data.name,
                paypwd: data.paypwd
            };
        }
        
        axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, formData)
            .then((res) => {
                swal({ title: "Thông báo", text: "Đăng ký thành công", icon: "success", buttons: "OK" })
                .then(() => {
                    axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                        username: data.username.toLowerCase(),
                        password: data.password
                    }).then((res) => {
                        localStorage.removeItem("user");
                        localStorage.removeItem("profile");
                        localStorage.removeItem("data");
                        localStorage.setItem("user", res.data.data);
                        localStorage.setItem("password", data.password);
                        navigate("/?notify");
                    });
                });
            })
            .catch((err) => swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error"));
    };

    return (
        <AnimatedPage>
            <style>{`
                /* FIX LỖI KHÔNG CUỘN ĐƯỢC */
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #f5f5f5;
                    margin: 0; padding: 0;
                }
                
                .reg-bg-container {
                    background-image: url('https://dztwieyphe62d.cloudfront.net/content/images/sandsvn/reg_bg.png');
                    background-repeat: no-repeat;
                    background-position: center top;
                    background-size: cover;
                    background-attachment: fixed;
                    min-height: 100vh;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    padding-bottom: 80px; /* Tạo khoảng trống để cuộn */
                }

                .reg-form-wrapper {
                    width: 100%;
                    max-width: 500px;
                    padding: 20px 20px;
                    position: relative;
                }

                .reg-close-btn {
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    color: #555;
                    cursor: pointer;
                    z-index: 10;
                }

                .reg-logo-box {
                    text-align: center;
                    padding-top: 10px;
                    padding-bottom: 5px;
                }
                .reg-logo-box img {
                    height: 55px;
                    object-fit: contain;
                }
                
                .reg-title-promo {
                    text-align: center;
                    color: #1174c3;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 25px;
                }
                
                .reg-form-group {
                    margin-bottom: 15px;
                }
                
                .reg-label-box {
                    display: flex;
                    align-items: center;
                    margin-bottom: 5px;
                    padding-left: 5px;
                }
                .reg-label-box span.star {
                    color: #e91e63;
                    font-size: 16px;
                    margin-right: 5px;
                }
                .reg-label-box label {
                    color: #1174c3;
                    font-size: 15px;
                    font-weight: bold;
                    margin: 0;
                }
                
                .reg-input-wrapper {
                    position: relative;
                    width: 100%;
                }
                .reg-input-wrapper input {
                    width: 100%;
                    height: 46px;
                    padding: 0 45px 0 15px;
                    border: 1px solid #d1d5da;
                    border-radius: 25px;
                    font-size: 14px;
                    color: #333;
                    background: #fff;
                    outline: none;
                }
                
                /* FIX ICON CON MẮT TO QUÁ KHỔ */
                .reg-input-icon {
                    position: absolute;
                    right: 15px;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    width: 24px;
                    height: 24px;
                }
                .reg-input-icon svg {
                    width: 20px !important;
                    height: 20px !important;
                    font-size: 20px !important;
                    fill: #666 !important;
                }
                
                .reg-error-text {
                    display: block;
                    font-size: 12px;
                    color: #d32f2f;
                    margin-top: 4px;
                    padding-left: 15px;
                    font-weight: 500;
                }
                
                .reg-checkbox-group {
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    margin-bottom: 15px;
                    padding-left: 5px;
                }
                .reg-checkbox-group input {
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;
                    accent-color: #1174c3;
                }
                .reg-checkbox-group span {
                    font-size: 13px;
                    color: #333;
                }
                
                .btn-submit-reg {
                    width: 100%;
                    background: #b71c1c;
                    color: #fff;
                    font-size: 18px;
                    font-weight: bold;
                    text-transform: uppercase;
                    border: none;
                    border-radius: 25px;
                    padding: 13px;
                    cursor: pointer;
                    box-shadow: 0 3px 6px rgba(0,0,0,0.2);
                    margin-bottom: 15px;
                }

                .reg-footer-links {
                    display: flex;
                    justify-content: space-between;
                    padding: 0 10px;
                }
                .reg-footer-links a {
                    font-size: 14px;
                    text-decoration: none;
                }
            `}</style>

            <div className="reg-bg-container">
                <div className="reg-form-wrapper">
                    
                    {/* Nút X đóng ở góc phải */}
                    <div className="reg-close-btn" onClick={() => navigate("/")}>
                        <CloseIcon sx={{ fontSize: "28px" }} />
                    </div>

                    <div className="reg-logo-box">
                        <img src="https://dztwieyphe62d.cloudfront.net/content/images/logo/logo-sandsvn.png" alt="Logo" />
                    </div>
                    <div className="reg-title-promo">Đăng ký nhận ngay 68K</div>

                    {err && <p className="reg-error-text" style={{ textAlign: "center", marginBottom: "10px" }}>{err}</p>}

                    <form onSubmit={handleSubmit(onSubmit)}>
                        
                        {/* 1. Tên tài khoản */}
                        <div className="reg-form-group">
                            <div className="reg-label-box">
                                <span className="star">★</span>
                                <label>tên tài khoản</label>
                            </div>
                            <div className="reg-input-wrapper">
                                <input type="text" maxLength="20" placeholder="Tên tài khoản từ 6-20 ký tự..." {...register("username", { required: true })} />
                            </div>
                            {errors.username && <span className="reg-error-text">{errors.username.message}</span>}
                        </div>

                        {/* 2. Mật khẩu */}
                        <div className="reg-form-group">
                            <div className="reg-label-box">
                                <span className="star">★</span>
                                <label>mật khẩu</label>
                            </div>
                            <div className="reg-input-wrapper">
                                <input type={showPassword ? "text" : "password"} placeholder="Mật khẩu từ 6 ký tự..." {...register("password", { required: true })} />
                                <div className="reg-input-icon" onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </div>
                            </div>
                            {errors.password && <span className="reg-error-text">{errors.password.message}</span>}
                        </div>

                        {/* 3. Xác nhận mật khẩu */}
                        <div className="reg-form-group">
                            <div className="reg-label-box">
                                <span className="star">★</span>
                                <label>Xác nhận mật khẩu</label>
                            </div>
                            <div className="reg-input-wrapper">
                                <input type={showPassword1 ? "text" : "password"} placeholder="Nhập lại mật khẩu..." {...register("ippassword", { required: true })} />
                                <div className="reg-input-icon" onClick={() => setShowPassword1(!showPassword1)}>
                                    {showPassword1 ? <Visibility /> : <VisibilityOff />}
                                </div>
                            </div>
                            {errors.ippassword && <span className="reg-error-text">{errors.ippassword.message}</span>}
                        </div>

                        {/* 4. Họ và tên */}
                        <div className="reg-form-group">
                            <div className="reg-label-box">
                                <span className="star">★</span>
                                <label>Họ và tên</label>
                            </div>
                            <div className="reg-input-wrapper">
                                <input type="text" placeholder="Viết Họ Tên Đầy Đủ, Chữ In Hoa Không Dấu" {...register("name", { required: true })} />
                            </div>
                            {errors.name && <span className="reg-error-text">{errors.name.message}</span>}
                        </div>

                        {/* 5. Số điện thoại */}
                        <div className="reg-form-group">
                            <div className="reg-label-box">
                                <span className="star">★</span>
                                <label>Số điện thoại</label>
                            </div>
                            <div className="reg-input-wrapper">
                                <input type="number" placeholder="Nhập số điện thoại chính chủ" {...register("sdt", { required: true })} />
                            </div>
                            {errors.sdt && <span className="reg-error-text">{errors.sdt.message}</span>}
                        </div>

                        {/* 6. Mật khẩu rút tiền */}
                        <div className="reg-form-group">
                            <div className="reg-label-box">
                                <span className="star">★</span>
                                <label>Mật khẩu rút tiền</label>
                            </div>
                            <div className="reg-input-wrapper">
                                <input type={showPassword2 ? "text" : "password"} placeholder="Tối thiểu 6 ký tự" {...register("paypwd", { required: true })} />
                                <div className="reg-input-icon" onClick={() => setShowPassword2(!showPassword2)}>
                                    {showPassword2 ? <Visibility /> : <VisibilityOff />}
                                </div>
                            </div>
                            {errors.paypwd && <span className="reg-error-text">{errors.paypwd.message}</span>}
                        </div>

                        {/* 7. Mã giới thiệu */}
                        {affiliate == null && (
                            <div className="reg-form-group">
                                <div className="reg-label-box">
                                    <span className="star">★</span>
                                    <label>Mã giới thiệu</label>
                                </div>
                                <div className="reg-input-wrapper">
                                    <input type="text" placeholder="Mã giới thiệu (nếu có)" {...register("code")} />
                                </div>
                            </div>
                        )}

                        <div className="reg-checkbox-group">
                            <input type="checkbox" defaultChecked id="agree" />
                            <label htmlFor="agree">Tôi đã hiểu Thỏa thuận đăng ký người dùng</label>
                        </div>

                        <button type="submit" className="btn-submit-reg">GỬI</button>

                        <div className="reg-footer-links">
                            <Link to="/" style={{ color: '#1174c3', fontWeight: 'bold' }}>Trang chủ</Link>
                            <Link to="/login" style={{ color: '#333' }}>
                                <i>Bạn đã có tài khoản?</i> <b style={{ color: '#b71c1c' }}>Đăng nhập</b>
                            </Link>
                        </div>

                    </form>
                </div>
            </div>
        </AnimatedPage>
    );
}

export default Register;